import { provideErrorHandler } from './_services/sentry-error-handler.service';
const ɵ0 = provideErrorHandler;
export class AppModule {
}
export { ɵ0 };
